"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationsService = void 0;
class NotificationsService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * get user notification settings
     * @returns UserNotificationSettingsResponse
     * @throws ApiError
     */
    getUserNotificationSettings() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/notifications/settings/',
        });
    }
    /**
     * upsert user notification settings
     * @param requestBody
     * @returns UpdateResponse
     * @throws ApiError
     */
    upsertUserNotificationSettings(requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/notifications/settings/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * list user notifications
     * @param status
     * @param page
     * @param count
     * @returns ListNotificationsResponse
     * @throws ApiError
     */
    listUserNotifications(status, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/notifications/',
            query: {
                'status': status,
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * updates user notifications status
     * @param requestBody
     * @returns UpdateResponse
     * @throws ApiError
     */
    updateNotificationStatus(requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/notifications/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
exports.NotificationsService = NotificationsService;
